var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconContainersOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.6834 10.0435L16.5002 16.5002L5.3125 10.0332",
    stroke: "#EE7203",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 16.5V28.5",
    stroke: "#EE7203",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5013 3.74434C16.1201 3.38708 16.8825 3.38708 17.5013 3.74434L27.0483 9.25631C27.6671 9.61358 28.0483 10.2738 28.0483 10.9884V22.0123C28.0483 22.7268 27.6671 23.3871 27.0483 23.7443L17.5013 29.2563C16.8825 29.6136 16.1201 29.6136 15.5013 29.2563L5.9543 23.7443C5.33549 23.3871 4.9543 22.7268 4.9543 22.0123V10.9884C4.9543 10.2738 5.33549 9.61357 5.9543 9.25631L15.5013 3.74434Z",
    stroke: "#EE7203",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.832 6.5L21.832 12.5",
    stroke: "#EE7203",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconContainersOrange);
export default __webpack_public_path__ + "static/media/icon-containers-orange.166e4b3c147db0a5e31a1d66643ae762.svg";
export { ForwardRef as ReactComponent };